import { VideoProviderTypes } from '@app/entities/enums/media-player/media-player.enum';
import { PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { applyMixins } from '@shared/utils/utils';

import { AbstractMultimediaItem } from './multimedia.abstract.model';
import { Publication } from './publication.model';
import { VideoQualities } from './video-qualities.model';
import { Video, VideoPublication } from './video.model';

export class ImageItem {
  alt!: string;
  caption!: string;
  thumb!: string;
  src!: string;
}

export class VideoItem {
  idVideo!: string;
  videoProvider!: VideoProviderTypes;
  iframe!: boolean;
  thumb!: string;
  src!: string;
  videos!: VideoQualities[];
  videoImage!: string;
  detailVideo?: Video;
}

export abstract class Multimedia extends AbstractMultimediaItem {
  abstract contentType: PublicationContentType.MULTIMEDIA;
  multiple?: {
    type: string;
    image?: ImageItem;
    video?: VideoItem;
  }[];

  init(data: MSafeAny) {
    this.multiple = data.multiple || [];
  }
}

export class MultimediaPublication extends Publication implements Multimedia {
  contentType: PublicationContentType.MULTIMEDIA = PublicationContentType.MULTIMEDIA;
  multiple?: {
    type: string;
    image?: ImageItem;
    video?: VideoItem;
  }[];

  init!: (data: MSafeAny) => void;
  loadDataVideo(data: MSafeAny) {
    if (data.multiple) {
      data.multiple.forEach((item: MSafeAny) => {
        if (item.type === PublicationContentType.VIDEO) {
          const video = {
            idVideo: item.id_video,
            videoProvider: item.video_provider,
            videoImage: item.video_image,
            videos: item.videos,
            url: item.src
          } as MSafeAny;

          item.detailVideo = new VideoPublication(video);
        }
      });
    }
  }

  constructor(data: MSafeAny) {
    super(data);
    this.loadDataVideo(data);
    this.init(data);
  }
}

applyMixins(MultimediaPublication, [Multimedia]);
